export const raidInfos = [
  {
    id: 1,
    startDate: '2025-11-10T00:00:00.000Z',
    endDate: '2025-11-17T00:00:00.000Z', //mettre à j+1 du dernier jour
    tagLine: `100% GAGNANT !! Assurer votre bonus collectif ET gagner des lots pour votre classe. Un acte de SOLIDARITÉ pour la classe et SIMPLE à réaliser.`,
    buttonLink:
      'https://drive.google.com/file/d/12MrxUn6l1iilKHmh2iEfiFsLef4ZeWgY/view?ts=6908ac4a',
    display: true
  }
];
